import { useGetAllEmployeeGroups } from '@hr/api/endpoints'
import { IconEmployeeGroup } from '@hr/common/icons'
import { LoadingContainer } from '@hr/common/loaders/loadingcontainer'
import { useTranslation } from 'react-i18next'
import styles from './Card.module.css'

export function NumberOfEmployeeGroups() {
	const { t } = useTranslation()

	const { data: groups } = useGetAllEmployeeGroups()

	const countGroups = () => {
		let count = 0
		groups.forEach((group) => {
			if (group.active) ++count
		})

		return (
			<>
				<h4 className={styles.cardHeader}>{t('EmployeeGroups', 'Työntekijäryhmät')}</h4>
				<IconEmployeeGroup />
				<b className={styles.bigFigure}>{count}</b>
				{t('pcs', 'kpl')}
			</>
		)
	}

	return groups ? countGroups() : <LoadingContainer />
}
